export { UserDetailsPanel } from './UserDetailsPanel';
